const NEW_LOGO = "/images/logo.svg";

export default {
  data() {
    return {
      isCustomProvideLogin: false,
    };
  },

  computed: {
    savedProvider() {
      return this.$store.state.layout.provider;
    },

    whitelabelLogoUrl() {
      return this.$store.getters["accountWhitelabel/logoUrl"];
    },

    hasAccountWhitelabel() {
      return this.$store.getters["accountWhitelabel/isApplied"];
    },

    hasSavedProvider() {
      return !!this.savedProvider;
    },

    isVivoProvider() {
      return this.$store.getters["layout/isVivoProvider"];
    },

    providerColor(){
        return this.$store.getters["layout/providerColor"];
    },

    isWhitelabel(){
        return this.$store.getters["layout/isWhitelabel"];
    },

    // O wordmark novo e 197x24; as logos dos providers sao raster com outra proporcao.
    // As telas usam isto para aplicar o dimensionamento novo somente a logo nova.
    usesNewLogo() {
      return this.logoUrl === NEW_LOGO;
    },

    logoUrl() {
      if (this.whitelabelLogoUrl) return this.whitelabelLogoUrl;

      return {
            ["wcs"]:
              "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Intelligence_WCS.png",
            ["haggi"]:
              "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Haggi_NTCORP.png",
            ["ntcorp"]:
              "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_NTCORP.png",
            ["tely"]:
              "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Tely.png",
            ["data-carrier"]:
              "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Data_Carrier.jpg",
            ["vivo"]:
              "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Vivo.png",
            ["vero"]: "/images/logo/vero.png",
            ["unifique"]: "/images/logo/unifique.png",
            ["abc"]: "/images/logo/abc.png",
            ["wifeed"]: NEW_LOGO,
            ["master"]: "/images/logo/master.webp",
          }[this.savedProvider] || NEW_LOGO;
    },

    providerClasses() {
      return {
        "login_custom-provider": this.isCustomProvideLogin,
        "login-wcs": this.savedProvider === "wcs",
        "login-haggi": this.savedProvider === "haggi",
        "login-tely": this.savedProvider === "tely",
        "login-ntcorp": this.savedProvider === "ntcorp",
        "login-data-carrier": this.savedProvider === "data-carrier",
        "login-vivo": this.savedProvider === "vivo",
        "login-vero": this.savedProvider === "vero",
        "login-unifique": this.savedProvider === "unifique",
        "login-abc": this.savedProvider === "abc",
        "login-master": this.savedProvider === "master",
      };
    },
  },

  methods: {
    setWhitelabelClassOnBody() {
        if (this.hasAccountWhitelabel) return;

        const whitelabelClass = {
            "vivo": "login-vivo",
            "vero":  "login-vero",
            "unifique":  "login-unifique",
            "abc":  "login-abc",
            "wifeed":  "login-wifeed",
            'master': 'login-master'
        }[this.savedProvider] || "login-wifeed";

        if(this.isWhitelabel){
            document.body.classList.add(whitelabelClass);
        } else {
            document.body.classList.remove(whitelabelClass);
        }
    },
  },
};
